import { useState } from 'react';

import MenuPlan from 'classes/MenuPlan/Search/MenuPlan';
import MenuPlanList from 'classes/MenuPlan/Search/MenuPlanList';
import PublishingModal from 'components/desktop/MenuPlan/Search/PublishingModal/Index';
import SearchResultListRow from 'components/desktop/MenuPlan/Search/SearchResultListRow';
import clone from 'functions/clone';

interface IProps {
	archive: boolean;
	handleArchiveMenuPlan: (input: MenuPlan) => Promise<void>;
	handleRestoreMenuPlan: (input: MenuPlan) => Promise<void>;
	menuPlanList: MenuPlanList;
	setMenuPlanList: (input: MenuPlanList) => void;
}

const SearchResultListComponent = (props: IProps) => {
	const [selectedMenuPlanId, setSelectedMenuPlanId] = useState<string | null>(null);

	const reloadMenuPlanList = (): void => {
		props.setMenuPlanList(clone(props.menuPlanList));
	};

	return (
		<div className="d-flex flex-column">
			<PublishingModal
				selectedMenuPlanId={selectedMenuPlanId}
				setSelectedMenuPlanId={setSelectedMenuPlanId}
				reloadMenuPlanList={reloadMenuPlanList}
				menuPlan={props.menuPlanList.findById(selectedMenuPlanId ?? '')}
			/>
			{props.menuPlanList.all.map((e: MenuPlan, i: number) => {
				return (
					<div key={i}>
						<SearchResultListRow
							archive={props.archive}
							menuPlan={e}
							setSelectedMenuPlanId={setSelectedMenuPlanId}
							handleArchiveMenuPlan={props.handleArchiveMenuPlan}
							handleRestoreMenuPlan={props.handleRestoreMenuPlan}
							reloadMenuPlanList={reloadMenuPlanList}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default SearchResultListComponent;
